export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70cf85340ed3fde348a332507d280d2a00e5781b1f&name=pushAdClickData!'